import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLanguage } from "gqlTypes/globalTypes";
import * as React from "react";
import ReactSVG from "react-svg";
import { NavLink } from "..";
import { TypedSecondaryMenuQuery } from "./queries";
import "./scss/index.scss";
import twitter from "../../images/twitter.svg";
import youtube from "../../images/youtube.svg";
import facebook from "../../images/facebook.svg";
import linkedin from "../../images/linkedin.svg";
import instagram from "../../images/instagram.svg";
import footerFuh from "../../images/footerFuh.svg";
import paymentMethods from "../../images/paymentMethod.svg";
var language = useLanguage();

var Nav =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Nav, _React$PureComponent);

  function Nav() {
    _classCallCheck(this, Nav);

    return _possibleConstructorReturn(this, _getPrototypeOf(Nav).apply(this, arguments));
  }

  _createClass(Nav, [{
    key: "render",
    value: function render() {
      return React.createElement("footer", {
        className: "footer-nav"
      }, React.createElement("div", {
        className: "footerMan"
      }, React.createElement("div", {
        className: "container"
      }, React.createElement(TypedSecondaryMenuQuery, {
        variables: {
          languageCode: language.toUpperCase()
        }
      }, function (_ref) {
        var data = _ref.data;
        return data.shop.navigation.secondary.items.map(function (item) {
          return React.createElement("div", {
            className: "footer-nav__section",
            key: item.id
          }, React.createElement("h4", {
            className: "footer-nav__section-header"
          }, React.createElement(NavLink, {
            item: item
          })), React.createElement("div", {
            className: "footer-nav__section-content"
          }, item.children.map(function (subItem) {
            return React.createElement("p", {
              key: subItem.id
            }, React.createElement(NavLink, {
              item: subItem
            }));
          })));
        });
      }), React.createElement("div", {
        className: "webLinks"
      }, React.createElement("div", {
        className: "items-links"
      }, React.createElement("a", {
        href: "https://twitter.com/FUHCare",
        target: "_",
        rel: "noreferrer noopener nofollow"
      }, React.createElement(ReactSVG, {
        path: twitter
      }))), React.createElement("div", {
        className: "items-links"
      }, React.createElement("a", {
        href: "https://www.youtube.com/channel/UCdVUtHSIUGLSYedbJ2_aOAw",
        target: "_",
        rel: "noreferrer noopener nofollow"
      }, React.createElement(ReactSVG, {
        path: youtube
      }))), React.createElement("div", {
        className: "items-links"
      }, React.createElement("a", {
        href: "https://www.facebook.com/fakeehuniversityhospital/",
        target: "_",
        rel: "noreferrer noopener nofollow"
      }, React.createElement(ReactSVG, {
        path: facebook
      }))), React.createElement("div", {
        className: "items-links"
      }, React.createElement("a", {
        href: "https://www.linkedin.com/company/fakeehuniversityhospital/",
        target: "_",
        rel: "noreferrer noopener nofollow"
      }, React.createElement(ReactSVG, {
        path: linkedin
      }))), React.createElement("div", {
        className: "items-links"
      }, React.createElement("a", {
        href: "https://www.instagram.com/fakeehuniversityhospital/",
        target: "_",
        rel: "noreferrer noopener nofollow"
      }, React.createElement(ReactSVG, {
        path: instagram
      }))))), React.createElement("div", {
        className: "footer-bottom-wrapper"
      }, React.createElement("div", {
        className: "footer-left"
      }, React.createElement("a", {
        href: "https://fuhonline.com",
        target: "_",
        rel: "noreferrer noopener"
      }, React.createElement(ReactSVG, {
        path: footerFuh
      }))), React.createElement("div", {
        className: "credit"
      }, React.createElement("div", {
        className: "cretit-text-2 copy"
      }, "\xA9 2023 Fakeeh Care. All Rights Reserved."), React.createElement(ReactSVG, {
        path: paymentMethods
      })))));
    }
  }]);

  return Nav;
}(React.PureComponent);

export default Nav;